import { render, staticRenderFns } from "./MessageCount.vue?vue&type=template&id=150a8c60"
import script from "./MessageCount.vue?vue&type=script&lang=js"
export * from "./MessageCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports